// Instância axios separada de Service. Os interceptors compartilhados anexam
// Authorization a partir do token guardado, exibem toast no 429 e deslogam
// no 401. Esta chamada pública não faz nada disso.

import axios from 'axios';
import type { PublicSampleAnswer, PublicSampleChoice } from '../@types/PublicSample';

const { REACT_APP_AUTH_SERVER_BASE_URL } = process.env;

const http = axios.create({
  baseURL: REACT_APP_AUTH_SERVER_BASE_URL,
  timeout: 8000,
  withCredentials: false,
});

http.interceptors.request.use((config) => {
  // Valor `false` é omitido na serialização do axios, então um token
  // herdado dos defaults não sai nesta chamada pública.
  config.headers.set('Authorization', false);
  return config;
});

class PublicSampleService {
  static checkAnswer(choice: PublicSampleChoice): Promise<PublicSampleAnswer> {
    return http
      .post<PublicSampleAnswer>('/public/sample-question/answer', { choice }, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => response.data);
  }
}

export default PublicSampleService;
